import AppBar from '@mui/material/AppBar';
import { Tabs } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useTheme } from '@mui/material/styles';

/**
 * Renders an AppBar with Tabs for mobile navigation.
 * It accepts children elements for rendering the tabs, current mobile tab value, and a function to set the mobile tab value.
 * It uses MUI AppBar and Tabs components for styling.
 *
 * @component
 * @param {Array<ReactNode>} props.children - array of React nodes representing the tabs to be rendered
 * @param {any} props.mobileTab - the current value of the active mobile tab
 * @param {Function} props.setMobileTab - function to set the value of the active mobile tab
 * @returns {JSX.Element}
 */
const MobileNavBar = ({ children, mobileTab, setMobileTab }) => {
    const theme = useTheme();
    return (
        <AppBar
            position='sticky'
            sx={{
                boxShadow: 1,
                backgroundColor: theme.palette.background.panel,
                height: '4rem',
                zIndex: 20,
                top: 80
            }}
        >
            <Tabs
                value={mobileTab}
                onChange={(e, index) => {
                    setMobileTab(index);
                }}
                TabIndicatorProps={{
                    sx: {
                        height: 4,
                        borderTopLeftRadius: '3px',
                        borderTopRightRadius: '3px'
                    }
                }}
                variant='fullWidth'
            >
                {children}
            </Tabs>
        </AppBar>
    );
};

MobileNavBar.propTypes = {
    children: PropTypes.arrayOf(PropTypes.node),
    mobileTab: PropTypes.any,
    setMobileTab: PropTypes.func
};

export default MobileNavBar;
